module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI0NiIgaGVpZ2h0PSIxNDI1IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiIHN0cm9rZT0iI0E4QThBOCIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIuMzI2Ij48Y2lyY2xlIG9wYWNpdHk9Ii41NDQiIGN4PSI3MTEiIGN5PSI3OTAiIHI9IjMxNyIvPjxjaXJjbGUgb3BhY2l0eT0iLjY1OSIgY3g9IjcxMi41IiBjeT0iNzkxLjUiIHI9IjQ0MS41Ii8+PGNpcmNsZSBvcGFjaXR5PSIuNjE2IiBjeD0iNzExIiBjeT0iNzkxIiByPSI1MjMiLz48Y2lyY2xlIG9wYWNpdHk9Ii4zMjYiIGN4PSI3MTEuNSIgY3k9IjcxMS41IiByPSI3MTEuNSIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mercedes-circles-light.svg
// module id = TOvQ
// module chunks = 0